import React from 'react';

let SectionIndependentes = props => (
  <svg {...props}>
    <path fill="currentColor" d="M20.049,6.609l-0.642-3.2H5.009v27.197h3.2V19.407h8.959l0.64,3.2h11.199V6.609H20.049z" />
  </svg>
);
SectionIndependentes = React.memo(SectionIndependentes);
SectionIndependentes.displayName = 'SectionIndependentes';

export default SectionIndependentes;
